"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizClientLineagePaneTitleBar = exports.lineagePanelTitleTestId = exports.lineagePanelCloseButtonTestId = void 0;
const tslib_1 = require("tslib");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const ViewerPaneStyles_1 = require("./ViewerPaneStyles");
exports.lineagePanelCloseButtonTestId = 'lineage-panel-close';
exports.lineagePanelTitleTestId = 'lineage-panel-title';
class VizClientLineagePaneTitleBar extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.domRef = react_1.default.createRef();
    }
    componentDidMount() {
        const rootElement = this.domRef.current;
        if (rootElement) {
            // find the element defined as focussable by the tabindex attribute
            const focusableElement = rootElement.querySelector('[tabindex="0"]');
            if (focusableElement) {
                focusableElement.focus();
            }
        }
    }
    renderCloseButton() {
        if (this.props.onCloseRequested === null) {
            return null;
        }
        return (react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Icon, handleClick: this.props.onCloseRequested, title: catalog_messages_1.Messages.CloseButtonTitle(), testId: exports.lineagePanelCloseButtonTestId, style: { padding: 0 }, getContent: () => react_1.default.createElement(catalog_icons_1.SvgCloseButton, null) }));
    }
    render() {
        return (react_1.default.createElement("div", { ref: this.domRef },
            react_1.default.createElement(ViewerPaneStyles_1.TitleBarContainer, null,
                react_1.default.createElement("h3", { className: ViewerPaneStyles_1.TitleTextCssClass, "data-tb-test-id": exports.lineagePanelTitleTestId }, this.props.title),
                this.renderCloseButton())));
    }
}
exports.VizClientLineagePaneTitleBar = VizClientLineagePaneTitleBar;
//# sourceMappingURL=VizClientLineagePanelTitleBar.js.map